import { Colors, Mixins, Spacing } from 'web-common/src/shared/styles';

export const TOGGLE_SWITCH_MARGIN = Mixins.Spacing.getSpacingValue(Spacing.EIGHTH);
export const DEFAULT_SIZE = Mixins.Spacing.getSpacingValue(Spacing.DOUBLE);

export const DEFAULT_CHECKED_COLOR = Colors.RADISH;
export const DEFAULT_UNCHECKED_COLOR = Colors.GRAY_DARK_10;
